Vue.component('sign-up-form', {
    data() {
        return {}
    },
});